class CoverCarouselSlideshow {
	constructor(block) {
		this.block = block;
		this.imagesContainer = block.querySelector(".cover-carousel-images");
		if (!this.imagesContainer) return;
		this.images = this.imagesContainer.querySelectorAll(
			".cover-carousel-image",
		);
		if (this.images.length < 2) return;
		this.timePerSlide =
			parseFloat(block.getAttribute("data-time-per-slide")) || 3;
		this.current = 0;
		this.init();
	}

	init() {
		// Ensure first image is active if none are
		const anyActive = Array.from(this.images).some(
			(img) => img.getAttribute("aria-hidden") === "false",
		);
		if (!anyActive && this.images.length > 0) {
			this.images[0].setAttribute("aria-hidden", "false");
		}
		// Show initial image immediately
		this.showImage(this.current);
		// Start interval
		this.interval = setInterval(() => {
			this.current = (this.current + 1) % this.images.length;
			this.showImage(this.current);
		}, this.timePerSlide * 1000);
	}

	showImage(idx) {
		this.images.forEach((img, i) => {
			img.setAttribute("aria-hidden", i === idx ? "false" : "true");
		});
	}
}

const carouselBlocks = new Set();

function setupCarousels() {
	document.querySelectorAll(".cover-carousel-block").forEach((block) => {
		if (!carouselBlocks.has(block)) {
			new CoverCarouselSlideshow(block);
			carouselBlocks.add(block);
		}
	});
}

// Initial setup as soon as script runs
setupCarousels();

// After page load, check for any new blocks that weren't added
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", setupCarousels);
} else {
	window.addEventListener("load", setupCarousels);
}
